import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessPaymentRunDetailEmployees } from '../dto/business-payment-run-detail-employees.dto';
import * as actions from '../actions';

export const businessPaymentRunDetailEmployeeFeatureKey = 'businessPaymentRunDetailEmployee';

export interface BusinessPaymentRunDetailEmployeeState {
  loadBusinessPaymentRunDetailEmployees: any;
  loadBusinessPaymentRunDetailEmployeesSuccess: IBusinessPaymentRunDetailEmployees[];
}

export const initialState: BusinessPaymentRunDetailEmployeeState = {
  loadBusinessPaymentRunDetailEmployees: undefined,
  loadBusinessPaymentRunDetailEmployeesSuccess: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinessPaymentRunDetailEmployees, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailEmployees: action.request
  })),
  on(actions.loadBusinessPaymentRunDetailEmployeesSuccess, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailEmployeesSuccess: action.response
  }))
);

export const getBusinessPaymentRunDetailEmployees = (state: BusinessPaymentRunDetailEmployeeState) =>
  state.loadBusinessPaymentRunDetailEmployeesSuccess;
